export default __webpack_public_path__ + "static/gs-1-upload-5f80a47450209dd16b96626daf4ceb1e.webp";